import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorEventosExtraordinariosService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async getEventosExtraordinarios(cetip) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.get(path)
    }

    async getTemporarioEventosExtraordinarios(cetip) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.get(path)
    }

    async createCadastroEventosExtraordinarios(cetip, payload) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.post(path, payload)
    }

    async createCadastroTemporarioEventosExtraordinarios(cetip, payload) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.post(path, payload)
    }

    async updateCadastroEventoExtraordinario(cetip, eventoId, payload) {
        const safeCetip = encodeURIComponent(cetip)
        const safeEventoId = encodeURIComponent(eventoId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeCetip}/eventos-extraordinarios/${safeEventoId}`
        return this.request.patch(path, payload)
    }

    async deleteCadastroEventoExtraordinario(cetip, eventoId) {
        const safeCetip = encodeURIComponent(cetip)
        const safeEventoId = encodeURIComponent(eventoId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeCetip}/eventos-extraordinarios/${safeEventoId}`
        return this.request.delete(path)
    }

    async deleteCadastroEventosExtraordinarios(cetip) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.delete(path)
    }

    async deleteCadastroTemporarioEventosExtraordinarios(cetip) {
        const safeCetip = encodeURIComponent(cetip)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/eventos-extraordinarios`
        return this.request.delete(path)
    }
}

export default MotorEventosExtraordinariosService
